import script from "./AnimauxVue.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimauxVue.vue?vue&type=script&setup=true&lang=js"

import "../assets/css/animaux.css?vue&type=style&index=0&id=4b9e950e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9e950e"]])

export default __exports__